import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { SEO } from '@/components/features/SEO';
import { ROUTES } from '@/constants/routes';
import styles from './Privacy.module.css';

export function Privacy() {
    const navigate = useNavigate();

    return (
        <div className={styles.page}>
            <SEO
                title="Politica de Privacidad - Peru IA"
                description="Politica de privacidad de Peru IA. Conoce como protegemos tu informacion personal y los datos recopilados al usar nuestra plataforma."
                url="https://peruhonesto.com/privacy"
            />

            <nav className={styles.nav}>
                <div className={styles.navInner}>
                    <button
                        className={styles.backButton}
                        onClick={() => navigate(ROUTES.home)}
                    >
                        <IoChevronBack /> Volver al inicio
                    </button>
                </div>
            </nav>

            <main className={styles.content}>
                <h1>Politica de Privacidad</h1>
                <p className={styles.updated}>Ultima actualizacion: 5 de marzo de 2026</p>

                <section>
                    <h2>1. Responsable del tratamiento</h2>
                    <p>
                        Peru IA (peruhonesto.com) es un proyecto desarrollado por Qolca, una empresa de software
                        con sede en Peru. Para cualquier consulta sobre el tratamiento de datos personales,
                        puedes contactarnos en <a href="mailto:info@qolca.org">info@qolca.org</a>.
                    </p>
                </section>

                <section>
                    <h2>2. Informacion que recopilamos</h2>
                    <p>
                        Peru IA recopila la siguiente informacion cuando utilizas nuestra plataforma:
                    </p>
                    <ul>
                        <li><strong>Datos de cuenta:</strong> Correo electronico y contrasena cifrada cuando te registras.</li>
                        <li><strong>Conversaciones:</strong> Los mensajes que envias al asistente de IA se almacenan para proporcionarte el historial de chat.</li>
                        <li><strong>Datos de uso:</strong> Informacion anonima sobre como usas la plataforma (paginas visitadas, duracion de la sesion).</li>
                        <li><strong>Datos tecnicos:</strong> Direccion IP, tipo de navegador y dispositivo, utilizados para la seguridad y el funcionamiento del servicio.</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Como usamos tu informacion</h2>
                    <p>Usamos tu informacion para:</p>
                    <ul>
                        <li>Proporcionar y mantener el servicio de asistente electoral.</li>
                        <li>Guardar tu historial de conversaciones cuando tienes una cuenta.</li>
                        <li>Mejorar la calidad de las respuestas de la IA.</li>
                        <li>Proteger la plataforma contra uso indebido.</li>
                        <li>Cumplir con obligaciones legales.</li>
                    </ul>
                    <p>
                        <strong>No utilizamos tu informacion para identificar tus preferencias politicas,
                        perfilar tu orientacion de voto ni para ningun fin relacionado con campanas electorales.</strong>
                    </p>
                </section>

                <section>
                    <h2>4. Cookies y tecnologias similares</h2>
                    <p>
                        Peru IA utiliza cookies esenciales para el funcionamiento del servicio (autenticacion, preferencias de tema).
                        Tambien utilizamos Google AdSense, que puede emplear cookies para mostrar anuncios relevantes.
                        Google utiliza cookies como la cookie DART para publicar anuncios basados en las visitas
                        de los usuarios a este sitio y otros sitios en Internet.
                    </p>
                    <p>
                        Puedes desactivar el uso de la cookie DART visitando la
                        pagina de politica de privacidad de publicidad y de la red de contenido de Google.
                    </p>
                </section>

                <section>
                    <h2>5. Publicidad</h2>
                    <p>
                        Peru IA utiliza Google AdSense para mostrar anuncios. Google y sus socios publicitarios
                        pueden utilizar cookies para publicar anuncios basados en visitas previas a este sitio u otros sitios web.
                        Los usuarios pueden optar por no participar en la publicidad personalizada visitando la
                        Configuracion de Anuncios de Google.
                    </p>
                </section>

                <section>
                    <h2>6. Comparticion de datos</h2>
                    <p>
                        No vendemos, intercambiamos ni transferimos tu informacion personal a terceros.
                        Esto no incluye a los socios de confianza que nos ayudan a operar nuestro sitio web,
                        siempre que estas partes acuerden mantener esta informacion confidencial.
                    </p>
                    <p>Los servicios de terceros que utilizamos incluyen:</p>
                    <ul>
                        <li><strong>Anthropic (Claude):</strong> Para procesar las preguntas de los usuarios y generar respuestas. Los mensajes se envian sin datos de identificacion personal.</li>
                        <li><strong>Google AdSense:</strong> Para la publicacion de anuncios.</li>
                        <li><strong>Vercel:</strong> Para el alojamiento del sitio web.</li>
                        <li><strong>Render:</strong> Para el alojamiento del backend y la base de datos.</li>
                    </ul>
                </section>

                <section>
                    <h2>7. Seguridad de datos</h2>
                    <p>
                        Implementamos medidas de seguridad para proteger tu informacion personal,
                        incluyendo cifrado de contrasenas, tokens JWT para autenticacion,
                        limitacion de tasa de solicitudes y cabeceras de seguridad (CSP, HSTS).
                        Sin embargo, ninguna transmision por Internet es completamente segura y no podemos
                        garantizar la seguridad absoluta de tus datos.
                    </p>
                </section>

                <section>
                    <h2>8. Tus derechos</h2>
                    <p>De acuerdo con la legislacion peruana de proteccion de datos, tienes derecho a:</p>
                    <ul>
                        <li>Acceder a tus datos personales.</li>
                        <li>Solicitar la correccion de datos inexactos.</li>
                        <li>Solicitar la eliminacion de tu cuenta y datos asociados.</li>
                        <li>Retirar tu consentimiento en cualquier momento.</li>
                        <li>Oponerte al tratamiento de tus datos personales.</li>
                    </ul>
                    <p>
                        Para ejercer cualquiera de estos derechos, contactanos en{' '}
                        <a href="mailto:info@qolca.org">info@qolca.org</a>.
                    </p>
                </section>

                <section>
                    <h2>9. Usuarios invitados</h2>
                    <p>
                        Los usuarios que no se registran pueden usar el servicio como invitados.
                        Los datos de sesion de invitados se almacenan temporalmente en el navegador
                        y no se asocian con ninguna cuenta personal.
                    </p>
                </section>

                <section>
                    <h2>10. Uso de informacion por la IA</h2>
                    <p>
                        Las conversaciones pueden ser utilizadas de forma anonima y agregada para mejorar
                        la calidad del servicio. <strong>En ningun caso utilizamos las conversaciones para
                        identificar preferencias politicas individuales, crear perfiles de votantes, ni para
                        compartir informacion con actores politicos.</strong>
                    </p>
                </section>

                <section>
                    <h2>11. Retencion de datos</h2>
                    <p>
                        Los datos de cuentas registradas se conservan mientras la cuenta este activa.
                        Puedes solicitar la eliminacion de tu cuenta en cualquier momento, lo cual
                        eliminara tus datos personales y conversaciones de nuestros sistemas.
                    </p>
                </section>

                <section>
                    <h2>12. Cambios a esta politica</h2>
                    <p>
                        Podemos actualizar esta politica de privacidad periodicamente. Cualquier cambio
                        sera publicado en esta pagina con la fecha de actualizacion correspondiente.
                        El uso continuado de la plataforma constituye aceptacion de la politica vigente.
                    </p>
                </section>

                <section>
                    <h2>13. Contacto</h2>
                    <p>
                        Si tienes preguntas sobre esta politica de privacidad o sobre el tratamiento de tus
                        datos personales, puedes contactarnos en{' '}
                        <a href="mailto:info@qolca.org">info@qolca.org</a>.
                    </p>
                </section>
            </main>
        </div>
    );
}
